import PropTypes from "prop-types";
import React from "react";
import DocumentUpload from "../DocumentUpload";
import IntegrationType from "../IntegrationType";
import KitDownload from "../KitDownload";
import PermitForm from "../PermitForm";
import { TrailThread } from "../TrailThread";
import Storage from "../../../../utils/storage";
import TestApproval from "../TestApproval";
import MigrationApproval from "../MigrationApproval";

const Application = (props) => {
  const {
    state,
    selectType,
    docApproved,
    ipPermitForm,
    docUpload,
    kitDownloadStatus,
    selectIntTypeStatus,
    uploadStartStatus,
    uploadFinishStatus,
    ipFormStatus,
    publicKeyStatus,
    runTestStatus,
    scheduleMigrationStatus,
    docApproval,
    requestManager,
    ipPermitApproval,
    testApproval,
    migrationApproval,
    docs,
    migrationStart,
    managerId,
    runTests,
    applications,
    getSingleApplication,
  } = props;

  return (
    applications &&
    applications.map((trail, index) => (
      <div key={index}>
        {TrailThread(
          state,
          kitDownloadStatus,
          trail,
          selectIntTypeStatus,
          uploadStartStatus,
          uploadFinishStatus,
          ipFormStatus,
          publicKeyStatus,
          runTestStatus,
          scheduleMigrationStatus,
          docApproval,
          ipPermitApproval,
          testApproval,
          migrationApproval,
          requestManager
        )}

        <div className="nip-integration">
          {state.kit &&
          !kitDownloadStatus &&
          !selectIntTypeStatus &&
          !docApproval &&
          !docApproved &&
          !requestManager ? (
            <KitDownload goToNext={selectType} />
          ) : kitDownloadStatus &&
            !selectIntTypeStatus &&
            !docApproval &&
            !docApproved &&
            !requestManager ? (
            <IntegrationType goToNext={docUpload} />
          ) : kitDownloadStatus &&
            selectIntTypeStatus &&
            !docApproval &&
            !runTestStatus &&
            !testApproval ? (
            <DocumentUpload
              goToNext={ipPermitForm}
              goToPrev={docUpload}
              selection={Storage.get("selection")}
              acctNumber={Storage.get("account-number")}
              wsdlUrl={Storage.get("wsdl-url")}
              docApproval={docApproval}
              uploadFinishStatus={uploadFinishStatus}
              application={trail}
              docs={docs}
              getAllApplications={getSingleApplication}
              getSingleApplication={getSingleApplication}
            />
          ) : kitDownloadStatus &&
            selectIntTypeStatus &&
            docApproval &&
            !runTestStatus &&
            !testApproval ? (
            <PermitForm
              docApproval={docApproval}
              networkId={managerId}
              requestStatus={requestManager}
              applicationId={trail && trail.application_id}
              application={trail}
              goToNext={runTests}
              ipPermitForm={ipPermitForm}
              getAllApplications={getSingleApplication}
              goToPrev={ipPermitForm}
              ipApproval={ipPermitApproval}
            />
          ) : kitDownloadStatus &&
            selectIntTypeStatus &&
            docApproval &&
            runTestStatus &&
            !scheduleMigrationStatus ? (
            <TestApproval
              runTestStatus={runTestStatus}
              applicationId={trail && trail.application_id}
              testApproval={testApproval}
            />
          ) : (
            kitDownloadStatus &&
            selectIntTypeStatus &&
            docApproval &&
            runTestStatus &&
            testApproval &&
            scheduleMigrationStatus && (
              <MigrationApproval
                scheduleMigrationStatus={scheduleMigrationStatus}
                migrationApproval={migrationApproval}
                migrationStart={migrationStart}
              />
            )
          )}
        </div>
      </div>
    ))
  );
};

Application.propTypes = {
  applications: PropTypes.shape({
    map: PropTypes.func,
  }),
  docApproval: PropTypes.any,
  docApproved: PropTypes.any,
  docUpload: PropTypes.any,
  docs: PropTypes.any,
  getApplications: PropTypes.any,
  getSingleApplication: PropTypes.any,
  ipFormStatus: PropTypes.any,
  ipPermitApproval: PropTypes.any,
  ipPermitForm: PropTypes.any,
  kitDownloadStatus: PropTypes.any,
  managerId: PropTypes.any,
  migrationApproval: PropTypes.any,
  migrationStart: PropTypes.any,
  publicKeyStatus: PropTypes.any,
  requestManager: PropTypes.any,
  runTestStatus: PropTypes.any,
  runTests: PropTypes.any,
  scheduleMigrationStatus: PropTypes.any,
  selectIntTypeStatus: PropTypes.any,
  selectType: PropTypes.any,
  shareKeys: PropTypes.any,
  startIpSubmission: PropTypes.any,
  state: PropTypes.shape({
    kit: PropTypes.any,
  }),
  testApproval: PropTypes.any,
  uploadFinishStatus: PropTypes.any,
  uploadStartStatus: PropTypes.any,
};

export default Application;
